import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../../capabilities';
import { getPortalId } from '../../../common/utils';
import { GROW_GUIDE_FREE_COMPONENT } from '../../constants';
import { GROW_GUIDE_FREE_ID, GROW_GUIDE_TIERS } from '../constants';
import { getStyle, getGrowGuideQueryParams } from '../internal';
export const growGuideFreeComponentDef = defineComponent(GROW_GUIDE_FREE_COMPONENT, {
  name: GROW_GUIDE_FREE_COMPONENT,
  path: `/grow-guide-free/${getPortalId()}`,
  queryParams: getGrowGuideQueryParams(),
  capabilities: [capabilities.SHOW_COMPONENT_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
  iframeProps: {
    id: GROW_GUIDE_FREE_ID,
    style: getStyle({
      tier: GROW_GUIDE_TIERS.FREE
    }),
    ['data-test-id']: GROW_GUIDE_FREE_ID,
    title: 'Grow Guide Free'
  }
});